import { getLocale } from "../components/getRuleLocale";
import { getQuery } from "./browser";
import { getData } from "./api"
import localeMap from "./locale_map.json"
import { setDir } from "./dom";
interface LocaleMap {
  [index: string]: Array<string>
}

// 客户端传过来的locale可能不一致，通过本地map统一
function parseLocale(locale: string) {
  const map: LocaleMap = localeMap
  return Object.keys(map).find((t: string) => map[t].some(l => l === locale.toLowerCase())) || locale
}

export enum DeviceType {
  Band = "band",
  Watch = "watch"
}
export default class Base {
  locale: string
  supportedLocale: string
  fallback: string
  rawLocale: string
  model: string
  deviceType: DeviceType
  region: string
  docType?: string
  languageMap = {}
  tagId?: string
  wideTagId?: string
  constructor(docType?: string) {
    const { locale, fallback, rawLocale } = getLocale()
    this.locale = parseLocale(locale)
    this.rawLocale = rawLocale
    this.supportedLocale = this.locale
    this.fallback = fallback === locale ? "" : fallback
    this.model = getQuery("model")
    this.deviceType = DeviceType.Watch
    this.region = getQuery("region")
    this.docType = docType
    this.tagId = getQuery("tagId")
    this.wideTagId = getQuery("wideTagId")
    setDir(this.locale)
  }

  async init() {
    const urlParams = new URLSearchParams(window.location.href)
    let path = '/config/';
    //用户反馈解析单独的feedback json文件
    if (urlParams.has('tagId') && window.location.pathname.includes('feedback-faq')) {
      path += 'feedback.json'
    } else if (window.location.pathname.includes('user-guide')) {
      path += 'user_guide.json'
    } else if (window.location.pathname.includes('guidance')) {
      path += 'guidance.json'
    } else {
      path += 'privacy.json'
    }

    const { models = [] } = await getData(path)
    const m = models.find((t: any) => {
      if (t.regexp) {
        const regexp = new RegExp(t.regexp)
        return this.model.match(regexp)
      }
      return t.model === this.model || t.alias.includes(this.model)
    })
    if (m) {
      this.model = m.model
      this.deviceType = m.type
    }
  }

  async loadConfig(type = this.docType) {
    await this.init()
    return getData(`/language_map/${type}.json`)
  }
}
